<template>
    <div class="swagger_ui_component">
      <div class="p-4" >

<div class="row mt-2" style="padding-top: 10px; margin-bottom: 30px; vertical-align: middle;">
  <div class="col-3">
    <span class="navbar-brand">
      <img alt="Logo" width="150px" src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/koko_logo_9613b6f06a.png?updated_at=2023-05-11T04:39:19.139Z" />
    </span>
  </div>
  <div class="col-9">
    <h1 style="margin-top: 2%;"
    >
    <b>Api Documentation For Koko Microservices</b>
    </h1>
  </div>
</div>

<div
  class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4 py-5"
>
  <div class="col d-flex align-items-start">
    <div>
      <h3 class="fw-bold mb-0 fs-4">
        <a href="https://devapi.paykoko.com/api/users/api-docs/"
          target="_blank"
          >Auth Services</a
        >
      </h3>
      <p>Providing Description auth related api's</p>
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div>
      <h3 class="fw-bold mb-0 fs-4">
        <a href="https://devapi.paykoko.com/api/merchants/api-docs/"  target="_blank"
          >Merchant Services</a
        >
      </h3>
      <p>Providing Description merchant related api's</p>
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div>
      <h3 class="fw-bold mb-0 fs-4">
        <a href="https://devapi.paykoko.com/api/test/api-docs/"  target="_blank"
          >Online Consumer Services</a
        >
      </h3>
      <p>Providing Description online consumer related api's</p>
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div>
      <h3 class="fw-bold mb-0 fs-4">
        <a href="https://devapi.paykoko.com/api/customers/api-docs/"  target="_blank"
          >Offline Consumer Services</a
        >
      </h3>
      <p>Providing Description offile consumenr related api's</p>
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div>
      <h3 class="fw-bold mb-0 fs-4">
        <a href="https://devapi.paykoko.com/api/payment/api-docs/"  target="_blank"
          >Payment Services</a
        >
      </h3>
      <p>Providing Description payment related api's</p>
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div>
      <h3 class="fw-bold mb-0 fs-4">
        <a href="https://devapi.paykoko.com/api/emails/api-docs/"  target="_blank"
          >Notification Services</a
        >
      </h3>
      <p>Providing Description notification related api's</p>
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div>
      <h3 class="fw-bold mb-0 fs-4">
        <a href="https://devapi.paykoko.com/api/test/api-docs/"  target="_blank"
          >Admin Services</a
        >
      </h3>
      <p>Providing Description admin related api's.</p>
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div>
      <h3 class="fw-bold mb-0 fs-4">
        <a href="https://devapi.paykoko.com/api/scheduler-jobs/api-docs/"  target="_blank"
          >Scheduler Services</a
        >
      </h3>
      <p>Providing Description scheduler related api's.</p>
    </div>
  </div>
</div>
</div>
    </div>
  </template>
  
  <script>
  
  export default {
    name: "SwaggerUI",
    components: {
  
    },
    mounted() {
      document.title = "Buy Now Pay Later with Koko";
    },
    created(){
  
    },
  }
  </script>
  
  <style scoped>

  </style>
  
  